import { useMemo } from 'react';
import { useAuth } from '../../auth';
import { useSite } from '../../sites';

export const useAppAuth = () => {
  const { site } = useSite();
  const { isSigning, user } = useAuth();

  const value = useMemo(
    () => ({
      isSigning,
      useAppAccount: site?.useAppAccount ?? false,
      user,
    }),
    [isSigning, site, user],
  );

  return value;
};
